
import { Component } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import { SubOrderType } from '@/enums/SubOrderType';
import VFormBuilder from '../../shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import Notification from '@/mixins/Notification';
import { mixins } from 'vue-class-component';
import { namespace } from 'vuex-class';
import Filter from '@/interfaces/api/Filter';
import { PaymentMethod } from '@/enums/PaymentMethod';
import uuid from 'uuid/v4';
import LightspeedApiService from '@/api/http/LightspeedApiService';
import { Venue } from '@/interfaces/models/Venue';
import {
  CheckoutIntegration,
  HellotessTender,
  RevelIntegration,
  NcrIntegration,
  ArcavisIntegration,
  RevelPaymentMethodMapping,
  RevelOrderTypeMapping,
  NcrPaymentMethodMapping,
  NcrOrderTypeMapping,
  ArcavisPaymentMethodMapping,
} from '../../../interfaces/models/CheckoutIntegration';
import { SimphonyIntegration } from '@/interfaces/models/SimphonyIntegration';
import { LightspeedMenu } from '@/interfaces/models/LightspeedMenu';
import { DiscountArticle } from '@/interfaces/models/DiscountArticle';
import { RevelType } from '@/interfaces/models/RevelType';
import { VCard, VCardActions, VCardText, VDialog } from 'vuetify/lib';
import { venueFilter } from '@/util/helper';
import { TAX_RATES } from '@/util/constant';
import SimphonyApiService from '@/api/http/SimphonyApiService';
import SyncPricesApiService from '@/api/http/SyncPricesApiService';
import KostApiService from '@/api/http/KostApiService';
import RevelApiService from '@/api/http/RevelApiService';
import NcrApiService from '@/api/http/NcrApiService';
import { ValidationObserver } from 'vee-validate';
import { Permission } from '@/enums/Permission';
import { SimphonySyncMode } from '@/enums/SimphonySyncMode';
import { LightspeedSyncMode } from '@/enums/LightspeedSyncMode';
import { ExternalOrderProvider } from '@/enums/ExternalOrderProvider';
import { OrderType } from '@/enums/OrderType';
import { SimphonyPayloadField } from '@/enums/SimphonyPayloadField';
import { StockMode } from '@/enums/StockMode';
import { RevelSyncMode } from '@/enums/RevelSyncMode';
import { TranslateResult } from 'vue-i18n';
import { AxiosResponse } from 'axios';

const app = namespace('app');
const venue = namespace('venue');
const table = namespace('table');

const ANTARA = 'antara';
const DELIVERECT = 'deliverect';
const HELLOTESS = 'hellotess';
const GASTROFIX = 'gastrofix';
const SIMPHONY = 'simphony';
const LIGHTSPEED_K_SERIES = 'lightspeed_k_series';
const VECTRON = 'vectron';
const LINA_LOCAL = 'lina_local';
const LINA_WEB = 'lina_web';
const KOST = 'kost';
const REVEL = 'revel';
const NCR = 'ncr';
const ARCAVIS = 'arcavis';

interface SimphonyTender {
  tenderId: number;
  paymentMethod: string;
  name: string;
  uuid?: string;
}

interface SimphonyRevenueCenter {
  revenueCenter: string;
  type?: ExternalOrderProvider;
  subOrderType: SubOrderType.INSIDE | SubOrderType.DELIVERY | SubOrderType.TAKE_AWAY | SubOrderType.FOODSPOT;
}

interface Tender {
  paymentMethod: string;
  channelInside: string;
  channelTakeaway: string;
  channelDelivery: string;
  uuid?: string;
}

interface Table {
  table: string;
  name: string;
  channelDelivery: string;
  channelInside: string;
  channelTakeaway: string;
  uuid?: string;
  tenders: Tender[];
}

interface Deliverect {
  locationId: string;
  posLocationId: string;
  defaultChannel: string;
  useVirtualOrders: boolean;
  useSecondaryCodeAsCheckId: boolean;
  version: string;
  sendTipAsUnaccountedPayment: boolean;
  sendDiscount: boolean;
}

interface PriceType {
  orderProfile: string;
  value: string;
}

@Component({
  components: { VFormBuilder, VDialog, VCard, VCardText, VCardActions, ValidationObserver },
})
export default class CheckoutIntegrationForm extends mixins(StackedForm, Notification) {
  @app.State('venues') public venues!: Venue[];

  @venue.State('active') public activeVenue!: Venue;
  @venue.State('checkoutIntegration') public checkoutIntegration!: CheckoutIntegration;
  @venue.Action('getCheckoutIntegration') public getCheckoutIntegration!: any;
  @venue.Action('copyFromToVenue') public copyFromToVenue!: (fromTo: {
    from: string;
    to: string[];
  }) => Promise<Boolean>;

  @table.State('items') public tablesItem!: Table[];
  @table.Action('setFilter') public setFilter!: (filter: Filter) => void;
  @table.Action('fetch') public getTables!: any;

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
    integrationProps: InstanceType<typeof VFormBuilder> & { form: any };
    deliverectProps: InstanceType<typeof VFormBuilder> & { form: any };
    simphonyProps: InstanceType<typeof VFormBuilder> & { form: any };
    tableProps: InstanceType<typeof VFormBuilder> & any;
    tenderProps: InstanceType<typeof VFormBuilder> & any;
    simphonyTenderProps: InstanceType<typeof VFormBuilder> & any;
    simphonyTerminalRevenueCenterProps: InstanceType<typeof VFormBuilder> & any;
    simphonyPreOrderRevenueCenterProps: InstanceType<typeof VFormBuilder> & any;
    simphonyExternalOrderProviderRevenueCenterProps: InstanceType<typeof VFormBuilder> & any;
    hellotessTenderProps: InstanceType<typeof VFormBuilder> & any;
    lightspeedProps: InstanceType<typeof VFormBuilder> & any;
    vectronProps: InstanceType<typeof VFormBuilder> & any;
    kostProps: InstanceType<typeof VFormBuilder> & any;
    revelProps: InstanceType<typeof VFormBuilder> & any;
    revelPaymentMethodMappingProps: InstanceType<typeof VFormBuilder> & any;
    revelOrderTypeMappingProps: InstanceType<typeof VFormBuilder> & any;
    ncrProps: InstanceType<typeof VFormBuilder> & any;
    ncrPaymentMethodMappingProps: InstanceType<typeof VFormBuilder> & any;
    ncrOrderTypeMappingProps: InstanceType<typeof VFormBuilder> & any;
    arcavisProps: InstanceType<typeof VFormBuilder> & any;
    arcavisPaymentMethodMappingProps: InstanceType<typeof VFormBuilder> & any;
    observer: InstanceType<typeof ValidationObserver>;
  };
  public antara: string = ANTARA;
  public deliverect: string = DELIVERECT;
  public hellotess: string = HELLOTESS;
  public gastrofix: string = GASTROFIX;
  public simphony: string = SIMPHONY;
  public lightspeedKSeries: string = LIGHTSPEED_K_SERIES;
  public linaLocal: string = LINA_LOCAL;
  public linaWeb: string = LINA_WEB;
  public vectron: string = VECTRON;
  public kost: string = KOST;
  public revel: string = REVEL;
  public ncr: string = NCR;
  public arcavis: string = ARCAVIS;
  public typeConfiguration: string = '';
  public initiatedStatus: boolean = false;
  public prices: PriceType[] = [];
  public lightspeedMenus: LightspeedMenu[] = [];
  public discountAsArticlesEnabled: boolean = false;
  public discountArticles: DiscountArticle[] = [];

  public copyVenueDialog: boolean = false;
  public copyVenueModel: {
    from: string;
    to: string[];
  } = {
    from: '',
    to: [],
  };
  public toVenueArray: Venue[] = [];

  public initialDeliverectVelues: Deliverect = {
    locationId: '',
    posLocationId: '',
    defaultChannel: '',
    useVirtualOrders: false,
    useSecondaryCodeAsCheckId: false,
    version: 'v2',
    sendTipAsUnaccountedPayment: false,
    sendDiscount: false,
  };

  public initialSimphonyValues: Partial<SimphonyIntegration> = {
    serviceUrl: '',
    orgname: '',
    orgShortName: '',
    locRef: '',
    rvcRef: '',
    username: '',
    password: '',
    clientId: '',
    authUrl: '',
    cancelTenderType: null,
    cashPaymentCancelTimeout: null,
    useExternalId: false,
    useSanifairAsTender: false,
    useTableAsEmployee: false,
    useCodeAsOrderCode: false,
    useSecondaryCodeAsOrdercode: false,
    defaultEmployee: null,
    defaultOrderType: null,
    orderTypeInside: null,
    orderTypeTakeAway: null,
    orderTypeDelivery: null,
    orderTypeFoodspot: null,
    serviceChargeTip: null,
    serviceChargeDeliveryFee: null,
    orderTypeInsideTerminal: null,
    orderTypeTakeAwayTerminal: null,
    firetimeEnabled: false,
    firetimeOffset: null,
    averageDeliveryTime: null,
    sendOrderNotes: false,
    hideTableName: false,
    healthcheckEnabled: false,
    multiConventional: false,
    useCancelTenderType: false,
    excludedTenders: null,
    multiConventionalRevenueCenters: null,
    sentBoardingPassEnabled: false,
    sentRbiLoyaltyEnabled: false,
    recalculatePayment: false,
    useSimphonyPrice: false,
    replaceCashOrdersByVirtualOrders: false,
    deepHierarchyOnMultiConventionalOrders: false,
    autoSyncEnabled: false,
    priceSequence: 1,
    cncEnabled: false,
    webhookEnabled: false,
    useNotesAsOrderCodeEnabled: false,
    retryOnApiCrash: false,
    skipRetryOnPosError: false,
    priceAutoSyncEnabled: false,
    useZeroCode: false,
    simphonyOrderTypes: [],
    disabledFields: [],
    useNotesAsOrderCode: null,
    cncAuthUrl: null,
    cncUsername: null,
    cncPassword: null,
    cncClientId: null,
    cncApiUrl: null,
    cncHierUnit: null,
  };

  public tables: Table[] = [];
  public simphonyTenders: SimphonyTender[] = [];
  public simphonyTerminalRevenueCenters: SimphonyRevenueCenter[] = [];
  public simphonyPreOrderRevenueCenters: SimphonyRevenueCenter[] = [];
  public simphonyExternalOrderProviderRevenueCenters: SimphonyRevenueCenter[] = [];
  public hellotessTenders: HellotessTender[] = [];
  public revelMainInitial: RevelIntegration = {
    enabled: false,
    apiKeyId: '',
    apiKeySecret: '',
    apiUrl: '',
    establishmentId: 0,
    paymentMethodMappings: [],
    orderTypeMappings: [],
  };
  public revelPaymentMethodMappings: RevelPaymentMethodMapping[] = [];
  public revelOrderTypeMappings: RevelOrderTypeMapping[] = [];
  public ncrMainInitial: NcrIntegration = {
    nepOrganization: '',
    nepEnterpriseUnit: '',
    secretKey: '',
    sharedKey: '',
    paymentMethodMappings: [],
    orderTypeMappings: [],
  };
  public ncrPaymentMethodMappings: NcrPaymentMethodMapping[] = [];
  public ncrOrderTypeMappings: NcrOrderTypeMapping[] = [];
  public arcavisMainInitial: ArcavisIntegration = {
    integrationKey: '',
    username: '',
    password: '',
    license: '',
    tipPaymentMethod: '',
    paymentMethodMappings: [],
  };
  public arcavisPaymentMethodMappings: ArcavisPaymentMethodMapping[] = [];
  public revelTypes: RevelType[] = [];
  public selectedLightspeedSyncMode: LightspeedSyncMode | null = null;
  public selectedRevelSyncMode: RevelSyncMode | null = null;

  public subOrderTypes: SubOrderType[] = [
    SubOrderType.INSIDE,
    SubOrderType.DELIVERY,
    SubOrderType.TAKE_AWAY,
    SubOrderType.FOODSPOT,
  ];

  public simphonySyncButtons: Array<{
    label: TranslateResult;
    success: string;
    error: string;
    mode: SimphonySyncMode;
    v2?: boolean;
  }> = [
    {
      label: this.$t('simphony.syncFoodcard'),
      success: 'simphony.notification.foodcardSyncSuccess',
      error: 'simphony.notification.foodcardSyncError',
      mode: SimphonySyncMode.PRICE_AND_ACTIVE,
    },
    {
      label: this.$t('simphony.fullSync'),
      success: 'simphony.notification.foodcardSyncSuccess',
      error: 'simphony.notification.foodcardSyncError',
      mode: SimphonySyncMode.FULL,
      v2: true,
    },
    {
      label: this.$t('simphony.syncPrices'),
      success: 'simphony.notification.pricesSyncSuccess',
      error: 'simphony.notification.pricesSyncError',
      mode: SimphonySyncMode.PRICE_ONLY,
    },
    {
      label: `${this.$t('simphony.syncPrices')} (V2)`,
      success: 'simphony.notification.pricesSyncSuccess',
      error: 'simphony.notification.pricesSyncError',
      mode: SimphonySyncMode.PRICE_ONLY,
      v2: true,
    },
    {
      label: `${this.$t('simphony.addOnly')} (V2)`,
      success: 'simphony.notification.addOnlySuccess',
      error: 'simphony.notification.addOnlyError',
      mode: SimphonySyncMode.ADD_ONLY,
      v2: true,
    },
    {
      label: this.$t('simphony.syncActive'),
      success: 'simphony.notification.activeSyncSuccess',
      error: 'simphony.notification.activeSyncError',
      mode: SimphonySyncMode.ACTIVE_ONLY,
    },
    {
      label: `${this.$t('simphony.syncActive')} (V2)`,
      success: 'simphony.notification.activeSyncSuccess',
      error: 'simphony.notification.activeSyncError',
      mode: SimphonySyncMode.ACTIVE_ONLY,
      v2: true,
    },
  ];

  public async mounted() {
    this.copyVenueModel.from = this.activeVenue._id;
    const venue = this.initialValues as Venue;

    if (venue?.checkoutIntegration === this.lightspeedKSeries) {
      if (!this.$can(Permission.VENUE_CHECKOUTINTEGRATION_VIEW)) return;
      await this.getCheckoutIntegration({
        venue: venue._id,
        integrationType: venue.checkoutIntegration,
      });

      await this.getLightspeedMenus();
    }
  }

  public filter(item: Venue, queryText: string): boolean {
    return venueFilter(item, queryText.trim());
  }

  public onVenueCopyClose() {
    this.copyVenueDialog = false;
  }

  public async onVenueCopySave() {
    if (!this.copyVenueModel.to.length) {
      this.notifyError(this.$t('copy_venue.not_selected_to') as string);
    } else {
      try {
        await this.copyFromToVenue(this.copyVenueModel);
        this.notifySuccess(this.$t('copy_venue.success') as string);
      } catch (error) {
        console.log(error);
        this.notifyError(this.$t('copy_venue.error') as string);
      }

      this.copyVenueDialog = false;
    }
  }

  public async initData() {
    const active: Venue = this.initialValues as Venue;
    const venue: string = this.$route.params.id || '';
    this.initiatedStatus = true;

    if (venue) {
      await this.loadVenueTables(venue);
    }

    if (active?.checkoutIntegration) {
      await this.loadCheckoutIntegration(active);
      if (active.checkoutIntegration === this.revel) {
        await this.getRevelTypes();
      }
    }

    const integration = this.getData();
    if (integration && integration.checkoutIntegration) {
      this.typeConfiguration = integration.checkoutIntegration;
      this.handleCheckoutIntegration();
    }
  }

  public async loadVenueTables(venue: string) {
    this.$startLoading('table');
    this.setFilter({ venue });
    await this.getTables();
    this.$stopLoading('table');
  }

  public async loadCheckoutIntegration(active: Venue) {
    if (!this.$can(Permission.VENUE_CHECKOUTINTEGRATION_VIEW)) return;
    await this.getCheckoutIntegration({
      venue: active._id,
      integrationType: active.checkoutIntegration,
    });
  }

  public handleCheckoutIntegration() {
    if (this.checkoutIntegration?.lightspeed) {
      this.setupLightspeedIntegration();
    }

    if (this.checkoutIntegration?.deliverect) {
      this.setupDeliverectIntegration();
    }

    if (this.checkoutIntegration?.simphony) {
      this.setupSimphonyIntegration();
    }

    if (this.checkoutIntegration?.hellotess) {
      this.hellotessTenders = (this.checkoutIntegration.hellotess.tenders || []).map((tender: HellotessTender) => ({
        ...tender,
        uuid: uuid(),
      }));
    }

    if (this.checkoutIntegration?.revel) {
      this.revelMainInitial = JSON.parse(JSON.stringify(this.checkoutIntegration.revel));
      this.revelPaymentMethodMappings = this.revelMainInitial?.paymentMethodMappings || [];
      this.revelOrderTypeMappings = this.revelMainInitial?.orderTypeMappings || [];
    }

    if (this.checkoutIntegration?.ncr) {
      this.ncrMainInitial = JSON.parse(JSON.stringify(this.checkoutIntegration.ncr));
      this.ncrPaymentMethodMappings = this.ncrMainInitial?.paymentMethodMappings || [];
      this.ncrOrderTypeMappings = this.ncrMainInitial?.orderTypeMappings || [];
    }

    if (this.checkoutIntegration?.arcavis) {
      this.arcavisMainInitial = JSON.parse(JSON.stringify(this.checkoutIntegration.arcavis));
      this.arcavisPaymentMethodMappings = this.arcavisMainInitial?.paymentMethodMappings || [];
    }
  }

  public setupLightspeedIntegration() {
    this.prices = this.checkoutIntegration.lightspeed?.priceMappings?.prices
      ? [...this.checkoutIntegration.lightspeed.priceMappings.prices]
      : [];

    this.discountAsArticlesEnabled = this.checkoutIntegration.lightspeed?.discountAsArticlesEnabled ?? false;
    this.discountArticles = this.checkoutIntegration.lightspeed?.discountArticles
      ? [...this.checkoutIntegration.lightspeed.discountArticles]
      : [];
  }

  public setupDeliverectIntegration() {
    this.initialDeliverectVelues = { ...this.checkoutIntegration.deliverect };
    this.tables = this.checkoutIntegration.deliverect.tables.map((table: Table) => ({
      ...table,
      uuid: uuid(),
      tenders: table.tenders.map((tender: Tender) => ({
        ...tender,
        uuid: uuid(),
      })),
    }));
  }

  public setupSimphonyIntegration() {
    this.initialSimphonyValues = { ...this.checkoutIntegration.simphony };

    if (this.initialSimphonyValues?.excludedTenders) {
      const excludedTenders = this.initialSimphonyValues.excludedTenders as unknown as number[];
      this.initialSimphonyValues.excludedTenders = excludedTenders.join(',');
    }

    if (this.initialSimphonyValues?.multiConventionalRevenueCenters) {
      const multiConventionalRevenueCenters = this.initialSimphonyValues
        .multiConventionalRevenueCenters as unknown as number[];
      this.initialSimphonyValues.multiConventionalRevenueCenters = multiConventionalRevenueCenters.join(',');
    }

    if (this.initialSimphonyValues?.useNotesAsOrderCode?.enabled) {
      this.initialSimphonyValues.useNotesAsOrderCodeEnabled = this.initialSimphonyValues.useNotesAsOrderCode.enabled;
      this.initialSimphonyValues.simphonyOrderTypes = this.initialSimphonyValues.useNotesAsOrderCode.orderTypes || [];
    }

    this.simphonyTenders = (this.checkoutIntegration?.simphony?.tenders || []).map((tender: SimphonyTender) => ({
      ...tender,
      uuid: uuid(),
    }));

    this.simphonyTerminalRevenueCenters = this.checkoutIntegration?.simphony?.terminalRevenueCenterMapping || [];

    this.simphonyPreOrderRevenueCenters = this.checkoutIntegration?.simphony?.preOrderRevenueCenterMapping || [];

    this.simphonyExternalOrderProviderRevenueCenters =
      this.checkoutIntegration?.simphony?.externalOrderProviderRevenueCenterMapping || [];
  }

  public getInitiatedStatus() {
    return this.initiatedStatus;
  }

  get isCncEnabled() {
    return this.initialSimphonyValues.cncEnabled;
  }

  get orderTypes(): string[] {
    if (this.$isAdmin()) {
      return Object.values(OrderType);
    }
    return [OrderType.STANDARD, OrderType.PREORDER, OrderType.TERMINAL];
  }

  get simphonyPayloadFields() {
    return Object.values(SimphonyPayloadField);
  }

  get externalOrderProviders() {
    return Object.values(ExternalOrderProvider);
  }

  get lightspeedSyncModes() {
    return Object.values(LightspeedSyncMode).map((mode) => ({
      value: mode,
      text: this.$t(`lightspeed.modes.${mode}`),
    }));
  }

  get revelSyncModes() {
    return Object.values(RevelSyncMode).map((mode) => ({
      value: mode,
      text: this.$t(`revel.modes.${mode}`),
    }));
  }

  get menusSelectItems() {
    if (!this.lightspeedMenus) {
      return [];
    }

    return this.lightspeedMenus.map((menu: LightspeedMenu) => ({
      value: `${menu.ikentooMenuId}`,
      text: menu.menuName,
    }));
  }

  get stockModes() {
    return Object.values(StockMode).map((mode) => ({
      value: mode,
      text: this.$t(`stockMode.${mode}`),
    }));
  }

  get revelTypesSelectItems() {
    return this.revelTypes.map((type: RevelType) => ({
      value: type.id,
      text: type.name,
    }));
  }

  get taxes() {
    return TAX_RATES;
  }

  get checkoutIntegrationItems() {
    return [
      {
        name: 'checkoutIntegration',
        type: InputType.Select,
        default: 'none',
        label: 'venue.form.checkoutIntegration',
        items: this.checkoutIntegrationTypes,
        change: this.onConfChange,
      },
      {
        name: 'checkoutIn',
        type: InputType.Select,
        default: 'none',
        label: 'venue.form.checkoutIn',
        items: this.orderStatusTypes,
        disabled: this.ciSettingsDisabledCallback,
      },
      { name: 'stock', type: InputType.Text, label: 'venue.form.stock' },
      { name: 'hasPrinter', type: InputType.Checkbox, default: false, label: 'venue.form.printerIntegration' },
      {
        name: 'printIn',
        type: InputType.Select,
        default: 'none',
        label: 'venue.form.printIn',
        items: this.orderStatusTypes,
        disabled: this.printerSettingsDisabledCallback,
      },
    ];
  }

  /*  Important - only for Antara!  */
  get checkoutIntegrationProps() {
    return [
      {
        name: 'ip',
        type: InputType.Text,
        label: 'Ip',
        default: null,
        items: this.checkoutIntegrationTypes,
        visible: this.typeConfiguration === ANTARA,
        autocomplete: 'off',
      },
      {
        name: 'port',
        type: InputType.Text,
        label: 'Port',
        default: null,
        visible: this.typeConfiguration === ANTARA,
        autocomplete: 'off',
      },
      {
        name: 'storeId',
        type: InputType.Text,
        label: 'Store ID',
        default: null,
        rules: 'required',
        visible: this.typeConfiguration === ANTARA || this.typeConfiguration === HELLOTESS,
        autocomplete: 'off',
      },
      {
        name: 'gastrofixBusinessUnit',
        type: InputType.Text,
        default: null,
        label: 'Gastrofix Business Unit',
        visible: this.typeConfiguration === GASTROFIX,
        autocomplete: 'off',
      },
      {
        name: 'gastrofixApiKey',
        type: InputType.Text,
        default: null,
        label: 'Gastrofix Api Key',
        visible: this.typeConfiguration === GASTROFIX,
        autocomplete: 'off',
      },
      {
        name: 'hellotessApiBaseUrl',
        type: InputType.Text,
        default: null,
        label: 'Hellotess Api Base Url',
        rules: 'required',
        visible: this.typeConfiguration === HELLOTESS,
        autocomplete: 'off',
      },
      {
        name: 'hellotessApiKey',
        type: InputType.Text,
        default: null,
        label: 'Hellotess Api Key',
        rules: 'required',
        visible: this.typeConfiguration === HELLOTESS,
        autocomplete: 'off',
      },
      {
        name: 'paymentMethod',
        type: InputType.Text,
        default: null,
        label: 'Payment Method',
        rules: 'required',
        visible: this.typeConfiguration === HELLOTESS,
      },
      {
        name: 'useV2',
        type: InputType.Checkbox,
        default: false,
        label: 'Use V2',
        visible: this.typeConfiguration === HELLOTESS,
      },
      {
        name: 'scheduleSync',
        type: InputType.Checkbox,
        default: false,
        label: 'Schedule',
        disabled: true,
        visible: this.typeConfiguration === ANTARA,
      },
      {
        name: 'lastResult',
        type: InputType.Text,
        label: 'Last result',
        default: 'none',
        disabled: true,
        visible: this.typeConfiguration === ANTARA,
      },
    ];
  }

  get deliverectItemProps() {
    return [
      {
        name: 'locationId',
        type: InputType.Text,
        label: 'Location Id',
        rules: 'required',
        change: (value: string) => (this.initialDeliverectVelues.locationId = value),
        autocomplete: 'off',
      },
      {
        name: 'posLocationId',
        type: InputType.Text,
        label: 'Pos Location Id',
        rules: 'required',
        change: (value: string) => (this.initialDeliverectVelues.posLocationId = value),
        autocomplete: 'off',
      },
      {
        name: 'defaultChannel',
        type: InputType.Text,
        label: 'Default Channel',
        rules: 'required',
        change: (value: string) => (this.initialDeliverectVelues.defaultChannel = value),
      },
      {
        name: 'useVirtualOrders',
        type: InputType.Checkbox,
        default: false,
        label: 'Use Virtual Orders',
        rules: 'required',
        change: (value: boolean) => (this.initialDeliverectVelues.useVirtualOrders = value),
      },
      {
        name: 'useSecondaryCodeAsCheckId',
        type: InputType.Checkbox,
        default: false,
        label: 'Use Secondary Code As CheckId',
        rules: 'required',
        change: (value: boolean) => (this.initialDeliverectVelues.useSecondaryCodeAsCheckId = value),
      },
      {
        name: 'version',
        type: InputType.Select,
        label: 'Version',
        change: (value: string) => (this.initialDeliverectVelues.version = value),
        autocomplete: 'off',
        items: ['v2', 'v3'],
      },
      {
        name: 'sendTipAsUnaccountedPayment',
        type: InputType.Checkbox,
        label: 'Send Tip As Unaccounted Payment',
        change: (value: boolean) => (this.initialDeliverectVelues.sendTipAsUnaccountedPayment = value),
        autocomplete: 'off',
      },
      {
        name: 'sendDiscount',
        type: InputType.Checkbox,
        label: 'Send Discount as dedicated field',
        change: (value: boolean) => (this.initialDeliverectVelues.sendDiscount = value),
        autocomplete: 'off',
      },
    ];
  }

  get simphonyItemProps() {
    return [
      {
        name: 'serviceUrl',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.serviceUrl',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.serviceUrl = value),
        autocomplete: 'off',
      },
      {
        name: 'orgname',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.orgname',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.orgname = value),
        autocomplete: 'off',
      },
      {
        name: 'orgShortName',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.orgShortName',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.orgShortName = value),
        autocomplete: 'off',
      },
      {
        name: 'locRef',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.locRef',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.locRef = value),
        autocomplete: 'off',
      },
      {
        name: 'rvcRef',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.rvcRef',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.rvcRef = value),
        autocomplete: 'off',
      },
      {
        name: 'username',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.username',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.username = value),
        autocomplete: 'off',
      },
      {
        name: 'password',
        type: InputType.Password,
        label: 'venue.form.checkoutIntegrationProps.password',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.password = value),
        autocomplete: 'new-password',
      },
      {
        name: 'clientId',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.clientId',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.clientId = value),
        autocomplete: 'off',
      },
      {
        name: 'authUrl',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.authUrl',
        rules: 'required',
        change: (value: string) => (this.initialSimphonyValues.authUrl = value),
        autocomplete: 'off',
      },
      {
        name: 'defaultEmployee',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.defaultEmployee',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.defaultEmployee = value || null),
      },
      {
        name: 'defaultOrderType',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.defaultOrderType',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.defaultOrderType = value || null),
      },
      {
        name: 'orderTypeInside',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.orderTypeInside',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.orderTypeInside = value || null),
      },
      {
        name: 'orderTypeTakeAway',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.orderTypeTakeAway',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.orderTypeTakeAway = value || null),
      },
      {
        name: 'orderTypeDelivery',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.orderTypeDelivery',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.orderTypeDelivery = value || null),
      },
      {
        name: 'orderTypeFoodspot',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.orderTypeFoodspot',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.orderTypeFoodspot = value || null),
      },
      {
        name: 'serviceChargeTip',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.serviceChargeTip',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.serviceChargeTip = value || null),
      },
      {
        name: 'serviceChargeDeliveryFee',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.serviceChargeDeliveryFee',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.serviceChargeDeliveryFee = value || null),
      },
      {
        name: 'orderTypeInsideTerminal',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.orderTypeInsideTerminal',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.orderTypeInsideTerminal = value || null),
      },
      {
        name: 'orderTypeTakeAwayTerminal',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.orderTypeTakeAwayTerminal',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.orderTypeTakeAwayTerminal = value || null),
      },
      {
        name: 'firetimeOffset',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.firetimeOffset',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.firetimeOffset = value || null),
      },
      {
        name: 'averageDeliveryTime',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.averageDeliveryTime',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.averageDeliveryTime = value || null),
      },
      {
        name: 'cancelTenderType',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.cancelTenderType',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.cancelTenderType = value || null),
      },
      {
        name: 'cashPaymentCancelTimeout',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.cashPaymentCancelTimeout',
        rules: 'integer',
        change: (value: string) => (this.initialSimphonyValues.cashPaymentCancelTimeout = value || null),
      },
      {
        name: 'excludedTenders',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.excludedTenders',
        rules: 'list_of_integer',
        change: (value: string) => (this.initialSimphonyValues.excludedTenders = value || null),
      },
      {
        name: 'useExternalId',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useExternalId',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.useExternalId = value),
      },
      {
        name: 'useSanifairAsTender',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useSanifairAsTender',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.useSanifairAsTender = value),
      },
      {
        name: 'useTableAsEmployee',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useTableAsEmployee',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.useTableAsEmployee = value),
      },
      {
        name: 'useCodeAsOrderCode',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useCodeAsOrderCode',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.useCodeAsOrderCode = value),
      },
      {
        name: 'useSecondaryCodeAsOrdercode',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useSecondaryCodeAsOrdercode',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.useSecondaryCodeAsOrdercode = value),
      },
      {
        name: 'firetimeEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.firetimeEnabled',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.firetimeEnabled = value),
      },
      {
        name: 'sendOrderNotes',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.sendOrderNotes',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.sendOrderNotes = value),
      },
      {
        name: 'hideTableName',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.hideTableName',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.hideTableName = value),
      },
      {
        name: 'healthcheckEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.healthcheckEnabled',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.healthcheckEnabled = value),
      },
      {
        name: 'multiConventional',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.multiConventional',
        rules: '',
        change: (value: boolean) => (this.initialSimphonyValues.multiConventional = value),
      },
      {
        name: 'useCancelTenderType',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useCancelTenderType',
        change: (value: boolean) => (this.initialSimphonyValues.useCancelTenderType = value),
      },
      {
        name: 'sentBoardingPassEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.sentBoardingPassEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.sentBoardingPassEnabled = value),
      },
      {
        name: 'sentRbiLoyaltyEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.sentRbiLoyaltyEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.sentRbiLoyaltyEnabled = value),
      },
      {
        name: 'recalculatePayment',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.recalculatePayment',
        change: (value: boolean) => {
          this.initialSimphonyValues.recalculatePayment = value;
          if (!value) this.initialSimphonyValues.useSimphonyPrice = false;
        },
      },
      {
        name: 'useSimphonyPrice',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useSimphonyPrice',
        disabled: !this.initialSimphonyValues.recalculatePayment,
        change: (value: boolean) => (this.initialSimphonyValues.useSimphonyPrice = value),
      },
      {
        name: 'replaceCashOrdersByVirtualOrders',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.replaceCashOrdersByVirtualOrders',
        change: (value: boolean) => (this.initialSimphonyValues.replaceCashOrdersByVirtualOrders = value),
      },
      {
        name: 'deepHierarchyOnMultiConventionalOrders',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.deepHierarchyOnMultiConventionalOrders',
        change: (value: boolean) => (this.initialSimphonyValues.deepHierarchyOnMultiConventionalOrders = value),
      },
      {
        name: 'autoSyncEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.autoSyncEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.autoSyncEnabled = value),
      },
      {
        name: 'priceAutoSyncEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.priceAutoSyncEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.priceAutoSyncEnabled = value),
      },
      {
        name: 'cncEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.cncEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.cncEnabled = value),
      },
      {
        name: 'webhookEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.webhookEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.webhookEnabled = value),
      },
      {
        name: 'useNotesAsOrderCodeEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useNotesAsOrderCodeEnabled',
        change: (value: boolean) => (this.initialSimphonyValues.useNotesAsOrderCodeEnabled = value),
      },
      {
        name: 'retryOnApiCrash',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.retryOnApiCrash',
        change: (value: boolean) => (this.initialSimphonyValues.retryOnApiCrash = value),
      },
      {
        name: 'skipRetryOnPosError',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.skipRetryOnPosError',
        change: (value: boolean) => (this.initialSimphonyValues.skipRetryOnPosError = value),
      },
      {
        name: 'useZeroCode',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useZeroCode',
        change: (value: boolean) => (this.initialSimphonyValues.useZeroCode = value),
      },
      {
        name: 'disabledFields',
        type: InputType.Select,
        label: 'venue.form.checkoutIntegrationProps.disabledFields',
        items: this.simphonyPayloadFields,
        default: null,
        multiple: true,
        change: (value: SimphonyPayloadField[]) => (this.initialSimphonyValues.disabledFields = value),
      },
      {
        name: 'simphonyOrderTypes',
        type: InputType.Select,
        label: 'venue.form.orderType',
        items: this.orderTypes,
        default: null,
        multiple: true,
        visible: (formValues: any) => formValues.useNotesAsOrderCodeEnabled,
        change: (value: OrderType[]) => (this.initialSimphonyValues.simphonyOrderTypes = value),
      },
      {
        name: 'priceSequence',
        type: InputType.Text,
        default: 1,
        label: 'venue.form.checkoutIntegrationProps.priceSequence',
        rules: 'integer',
        change: (value: number) => (this.initialSimphonyValues.priceSequence = value),
        autocomplete: 'off',
      },
      {
        name: 'multiConventionalRevenueCenters',
        type: InputType.Text,
        default: null,
        label: 'venue.form.checkoutIntegrationProps.multiConventionalRevenueCenters',
        rules: 'list_of_integer',
        change: (value: string) => (this.initialSimphonyValues.multiConventionalRevenueCenters = value || null),
        autocomplete: 'off',
      },
      {
        name: 'cncAuthUrl',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.cncAuthUrl',
        visible: this.isCncEnabled,
        change: (value: string) => (this.initialSimphonyValues.cncAuthUrl = value || null),
        autocomplete: 'off',
      },
      {
        name: 'cncUsername',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.cncUsername',
        visible: this.isCncEnabled,
        change: (value: string) => (this.initialSimphonyValues.cncUsername = value || null),
        autocomplete: 'off',
      },
      {
        name: 'cncPassword',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.cncPassword',
        visible: this.isCncEnabled,
        change: (value: string) => (this.initialSimphonyValues.cncPassword = value || null),
        autocomplete: 'off',
      },
      {
        name: 'cncClientId',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.cncClientId',
        visible: this.isCncEnabled,
        change: (value: string) => (this.initialSimphonyValues.cncClientId = value || null),
        autocomplete: 'off',
      },
      {
        name: 'cncApiUrl',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.cncApiUrl',
        visible: this.isCncEnabled,
        change: (value: string) => (this.initialSimphonyValues.cncApiUrl = value || null),
        autocomplete: 'off',
      },
      {
        name: 'cncHierUnit',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.cncHierUnit',
        rules: 'integer',
        visible: this.isCncEnabled,
        change: (value: number) => (this.initialSimphonyValues.cncHierUnit = value || null),
        autocomplete: 'off',
      },
    ];
  }

  get lightspeedKSeriesProps() {
    return [
      {
        name: 'businessLocationId',
        type: InputType.Text,
        label: 'Business Location Id',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'businessId',
        type: InputType.Text,
        label: 'Business Id',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'menus',
        type: InputType.Autocomplete,
        label: 'Menus',
        multiple: true,
        items: this.menusSelectItems,
        visible: !this.$isLoading('lightspeed.menus') && this.menusSelectItems.length,
      },
      {
        name: 'floorplans',
        type: InputType.Combobox,
        label: 'Floorplans',
        multiple: true,
        default: [],
      },
      {
        name: 'multiConventionalOrderProfiles',
        type: InputType.Combobox,
        label: 'venue.form.checkoutIntegrationProps.multiConventionalOrderProfiles',
        multiple: true,
        default: [],
      },
      {
        name: 'deliveryArticleSku',
        type: InputType.Text,
        label: 'Delivery Fee Article SKU',
      },
      {
        name: 'inside',
        type: InputType.Text,
        label: 'Account/Order Profile (Inside)',
      },
      {
        name: 'takeAway',
        type: InputType.Text,
        label: 'Account/Order Profile (take away)',
      },
      {
        name: 'delivery',
        type: InputType.Text,
        label: 'Account/Order Profile (delivery)',
      },
      {
        name: 'woltTakeAway',
        type: InputType.Text,
        label: 'Wolt Account/Order Profile (take away)',
      },
      {
        name: 'woltDelivery',
        type: InputType.Text,
        label: 'Wolt Account/Order Profile (delivery)',
      },
      {
        name: 'uberEatsTakeAway',
        type: InputType.Text,
        label: 'Uber Account/Order Profile (take away)',
      },
      {
        name: 'uberEatsDelivery',
        type: InputType.Text,
        label: 'Uber Account/Order Profile (delivery)',
      },
      {
        name: 'jetTakeAway',
        type: InputType.Text,
        label: 'JET Account/Order Profile (take away)',
      },
      {
        name: 'jetDelivery',
        type: InputType.Text,
        label: 'JET Account/Order Profile (delivery)',
      },
      {
        name: 'deliverooTakeAway',
        type: InputType.Text,
        label: 'Deliveroo Account/Order Profile (take away)',
      },
      {
        name: 'deliverooDelivery',
        type: InputType.Text,
        label: 'Deliveroo Account/Order Profile (delivery)',
      },
      {
        name: 'terminalInsideProfile',
        type: InputType.Text,
        label: 'Account/Order Profile (Inside / Terminal)',
      },
      {
        name: 'terminalTakeAwayProfile',
        type: InputType.Text,
        label: 'Account/Order Profile (Take Away / Terminal)',
      },
      {
        name: 'webInside',
        type: InputType.Text,
        label: 'Account/Order Profile (Inside / Web)',
      },
      {
        name: 'webTakeAway',
        type: InputType.Text,
        label: 'Account/Order Profile (Take Away / Web)',
      },
      {
        name: 'webDelivery',
        type: InputType.Text,
        label: 'Account/Order Profile (Delivery / Web)',
      },
      {
        name: 'appInside',
        type: InputType.Text,
        label: 'Account/Order Profile (Inside / App)',
      },
      {
        name: 'appTakeAway',
        type: InputType.Text,
        label: 'Account/Order Profile (Take Away / App)',
      },
      {
        name: 'appDelivery',
        type: InputType.Text,
        label: 'Account/Order Profile (Delivery / App)',
      },
      {
        name: 'creditCard',
        type: InputType.Text,
        label: 'Payment Method Mapping (credit card)',
      },
      {
        name: 'pos',
        type: InputType.Text,
        label: 'Payment Method Mapping (pos)',
      },
      {
        name: 'cash',
        type: InputType.Text,
        label: 'Payment Method Mapping (cash)',
      },
      {
        name: 'applePay',
        type: InputType.Text,
        label: 'Payment Method Mapping (apple pay)',
      },
      {
        name: 'googlePay',
        type: InputType.Text,
        label: 'Payment Method Mapping (google pay)',
      },
      {
        name: 'paypal',
        type: InputType.Text,
        label: 'Payment Method Mapping (paypal)',
      },
      {
        name: 'boncard',
        type: InputType.Text,
        label: 'Payment Method Mapping (wallee/boncard)',
      },
      {
        name: 'sepa',
        type: InputType.Text,
        label: 'Payment Method Mapping (SEPA)',
      },
      {
        name: 'ec',
        type: InputType.Text,
        label: 'Payment Method Mapping (EC)',
      },
      {
        name: 'girocard',
        type: InputType.Text,
        label: 'Payment Method Mapping (Girocard)',
      },
      {
        name: 'mastercard',
        type: InputType.Text,
        label: 'Payment Method Mapping (Mastercard)',
      },
      {
        name: 'amex',
        type: InputType.Text,
        label: 'Payment Method Mapping (Amex)',
      },
      {
        name: 'visa',
        type: InputType.Text,
        label: 'Payment Method Mapping (VISA)',
      },
      {
        name: 'visaE',
        type: InputType.Text,
        label: 'Payment Method Mapping (Visa-E)',
      },
      {
        name: 'vPay',
        type: InputType.Text,
        label: 'Payment Method Mapping (V-Pay)',
      },
      {
        name: 'jcb',
        type: InputType.Text,
        label: 'Payment Method Mapping (JCB)',
      },
      {
        name: 'maestro',
        type: InputType.Text,
        label: 'Payment Method Mapping (Maestro)',
      },
      {
        name: 'postcard',
        type: InputType.Text,
        label: 'Payment Method Mapping (postcard)',
      },
      {
        name: 'alipay',
        type: InputType.Text,
        label: 'Payment Method Mapping (alipay)',
      },
      {
        name: 'diners',
        type: InputType.Text,
        label: 'Payment Method Mapping (diners)',
      },
      {
        name: 'lunchcheck',
        type: InputType.Text,
        label: 'Payment Method Mapping (lunchcheck)',
      },
      {
        name: 'reka',
        type: InputType.Text,
        label: 'Payment Method Mapping (reka)',
      },
      {
        name: 'twint',
        type: InputType.Text,
        label: 'Payment Method Mapping (twint)',
      },
      {
        name: 'chinaUnionPay',
        type: InputType.Text,
        label: 'Payment Method Mapping (China Union Pay)',
      },
      {
        name: 'wolt',
        type: InputType.Text,
        label: 'Payment Method Mapping (Wolt)',
      },
      {
        name: 'uberEats',
        type: InputType.Text,
        label: 'Payment Method Mapping (Uber-Eats)',
      },
      {
        name: 'jet',
        type: InputType.Text,
        label: 'Payment Method Mapping (Jet)',
      },
      {
        name: 'deliveroo',
        type: InputType.Text,
        label: 'Payment Method Mapping (Deliveroo)',
      },
      {
        name: 'zeroPayment',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.zeroPaymentMapping',
      },
      {
        name: 'postfinance',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.postfinanceMapping',
      },
      {
        name: 'piggyPrepaidBalance',
        type: InputType.Text,
        label: `Payment Method Mapping (${this.$t('venue.form.checkoutIntegrationProps.piggyPrepaidBalance')})`,
      },
      {
        name: 'piggyGiftCard',
        type: InputType.Text,
        label: `Payment Method Mapping (${this.$t('venue.form.checkoutIntegrationProps.piggyGiftCard')})`,
      },
      {
        name: 'preorderInside',
        type: InputType.Text,
        label: 'Price Mapping (Preorder Inside)',
      },
      {
        name: 'preorderTakeAway',
        type: InputType.Text,
        label: 'Price Mapping (Preorder TakeAway)',
      },
      {
        name: 'preorderDelivery',
        type: InputType.Text,
        label: 'Price Mapping (Preorder Delivery)',
      },
      {
        name: 'terminalInside',
        type: InputType.Text,
        label: 'Price Mapping (Terminal Inside)',
      },
      {
        name: 'terminalTakeAway',
        type: InputType.Text,
        label: 'Price Mapping (Terminal TakeAway)',
      },
      {
        name: 'woltPrice',
        type: InputType.Text,
        label: 'Price Mapping (Wolt)',
      },
      {
        name: 'uberEatsPrice',
        type: InputType.Text,
        label: 'Price Mapping (Uber-Eats)',
      },
      {
        name: 'jetPrice',
        type: InputType.Text,
        label: 'Price Mapping (Jet)',
      },
      {
        name: 'deliverooPrice',
        type: InputType.Text,
        label: 'Price Mapping (Deliveroo)',
      },
      {
        name: 'firetime',
        type: InputType.Decimal,
        default: null,
        label: 'Firetime',
      },
      {
        name: 'staticFiretime',
        type: InputType.Text,
        rules: 'time',
        default: null,
        label: 'Static Firetime',
      },
      {
        name: 'preparationTime',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.preparationTime',
        rules: `greater_eq_than:1`,
      },
      {
        name: 'deliveryTime',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.deliveryTime',
        rules: `greater_eq_than:1`,
      },
      {
        name: 'stockMode',
        type: InputType.Select,
        label: 'venue.form.checkoutIntegrationProps.stockMode',
        items: this.stockModes,
      },
      {
        name: 'posFlowEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'Pos Flow Enabled',
      },
      {
        name: 'multiConventional',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.multiConventional',
      },
      {
        name: 'autoSyncEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.autoSyncEnabled',
      },
      {
        name: 'allowManualBooking',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.allowManualBooking',
      },
      {
        name: 'useTerminalName',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.useTerminalName',
      },
      {
        name: 'sendTableNumberAsOrderNote',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.sendTableNumberAsOrderNote',
      },
      {
        name: 'financialApiEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.financialApiEnabled',
        readonly: true,
      },
      // Let's keep this below for better UX
      {
        name: 'discountAsArticlesEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.discountAsArticlesEnabled',
        change: (value: boolean) => {
          this.discountAsArticlesEnabled = value;

          if (value && !this.discountArticles?.length) {
            this.addDiscountArticle();
          }
        },
      },
    ];
  }

  get vectronItemsProps() {
    return [
      {
        name: 'clientId',
        type: InputType.Text,
        label: 'Client Id',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'url',
        type: InputType.Text,
        label: 'Url',
        rules: 'required',
        autocomplete: 'off',
      },
    ];
  }

  get kostItemsProps() {
    return [
      {
        name: 'clientId',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.clientId',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'clientSecret',
        type: InputType.Password,
        label: 'venue.form.clientSecret',
        rules: 'required',
        autocomplete: 'new-password',
      },
      {
        name: 'costCenter',
        type: InputType.Text,
        label: 'venue.form.costCenter',
        default: 0,
        rules: 'required|integer|greater_than:0',
        autocomplete: 'off',
      },
      {
        name: 'ecrNumber',
        type: InputType.Text,
        label: 'venue.form.ecrNumber',
        rules: 'required',
        autocomplete: 'off',
      },
    ];
  }

  get revelItemsProps() {
    return [
      {
        name: 'enabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.enabled',
      },
      {
        name: 'apiKeyId',
        type: InputType.Text,
        label: 'venue.form.apiKey',
        rules: 'required',
      },
      {
        name: 'apiKeySecret',
        type: InputType.Password,
        label: 'venue.form.apiSecret',
        rules: 'required',
        autocomplete: 'new-password',
      },
      {
        name: 'apiUrl',
        type: InputType.Text,
        label: 'venue.form.apiUrl',
        rules: 'required',
      },
      {
        name: 'establishmentId',
        type: InputType.Text,
        default: 0,
        label: 'venue.form.establishmentId',
        rules: 'required|integer|greater_than:0',
      },
    ];
  }

  get tableItemProps() {
    return [
      {
        name: 'uuid',
        value: 'uuid',
        default: uuid(),
        disabled: true,
        key: uuid(),
      },
      {
        name: 'table',
        type: InputType.Select,
        default: 'none',
        label: 'Table',
        items: this.tableItems,
        rules: 'required',
      },
      {
        name: 'name',
        type: InputType.Text,
        label: 'Name',
        rules: 'required',
      },
      {
        name: 'channelInside',
        type: InputType.Text,
        label: 'Channel Inside',
        rules: 'required',
      },
      {
        name: 'channelTakeaway',
        type: InputType.Text,
        label: 'Channel Takeaway',
        rules: 'required',
      },
      {
        name: 'channelDelivery',
        type: InputType.Text,
        label: 'Channel Delivery',
        rules: 'required',
      },
    ];
  }

  get tendersItemProps() {
    return [
      {
        name: 'uuid',
        value: 'uuid',
        disabled: true,
        default: uuid(),
        key: uuid(),
      },
      {
        name: 'paymentMethod',
        type: InputType.Select,
        default: 'none',
        label: 'Payment Method',
        items: this.paymentMethods,
        rules: 'required',
      },
      {
        name: 'channelInside',
        type: InputType.Text,
        label: 'Channel Inside',
        rules: 'required',
      },
      {
        name: 'channelTakeaway',
        type: InputType.Text,
        label: 'Channel Takeaway',
        rules: 'required',
      },
      {
        name: 'channelDelivery',
        type: InputType.Text,
        label: 'Channel Delivery',
        rules: 'required',
      },
    ];
  }

  get simphonyTendersItemProps() {
    return [
      {
        name: 'uuid',
        value: 'uuid',
        disabled: true,
        default: uuid(),
        key: uuid(),
      },
      {
        name: 'name',
        type: InputType.Text,
        label: 'Name',
        rules: 'required',
      },
      {
        name: 'tenderId',
        type: InputType.Text,
        label: 'Tender Id',
        rules: 'required',
      },
      {
        name: 'paymentMethod',
        type: InputType.Combobox,
        default: '',
        label: 'Payment Method',
        items: this.paymentMethods,
        clearable: true,
      },
    ];
  }

  get simphonyRevenueCenterItemProps() {
    return [
      {
        name: 'revenueCenter',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.revenueCenter',
        rules: 'required',
      },
      {
        name: 'subOrderType',
        type: InputType.Select,
        default: SubOrderType.INSIDE,
        label: 'venue.form.subOrderType',
        items: this.subOrderTypes,
        rules: 'required',
      },
    ];
  }

  get extendedSimphonyRevenueCenterItemProps() {
    return [
      ...this.simphonyRevenueCenterItemProps,
      {
        name: 'type',
        type: InputType.Select,
        default: ExternalOrderProvider.WOLT,
        label: 'venue.form.checkoutIntegrationProps.externalOrderProviderType',
        items: this.externalOrderProviders,
        rules: 'required',
      },
    ];
  }

  get hellotessTendersItemProps() {
    return [
      {
        name: 'uuid',
        value: 'uuid',
        disabled: true,
        default: uuid(),
        key: uuid(),
      },
      {
        name: 'name',
        type: InputType.Text,
        label: 'Name',
        rules: 'required',
      },
      {
        name: 'tenderId',
        type: InputType.Text,
        label: 'Tender Id',
        rules: 'required',
      },
      {
        name: 'paymentMethod',
        type: InputType.Combobox,
        default: 'none',
        label: 'venue.form.checkoutIntegrationProps.paymentMethod',
        items: this.paymentMethods,
        rules: 'required',
        clearable: true,
      },
    ];
  }

  get revelPaymentMethodMappingItemProps() {
    return [
      {
        name: 'isDefault',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.checkoutIntegrationProps.default',
      },
      {
        name: 'method',
        type: InputType.Combobox,
        default: 'none',
        label: 'venue.form.checkoutIntegrationProps.paymentMethod',
        items: this.paymentMethods,
        clearable: true,
      },
      {
        name: 'revelType',
        type: InputType.Text,
        default: 0,
        label: 'venue.form.checkoutIntegrationProps.revelType',
        rules: 'required|integer|greater_than:0',
      },
    ];
  }

  get revelOrderTypeMappingItemProps() {
    return [
      {
        name: 'type',
        type: InputType.Select,
        default: OrderType.PREORDER,
        label: 'venue.form.orderType',
        items: this.orderTypes,
        rules: 'required',
      },
      {
        name: 'subType',
        type: InputType.Select,
        default: SubOrderType.INSIDE,
        label: 'venue.form.subOrderType',
        items: this.subOrderTypes,
        clearable: true,
        rules: (form: any) => ([OrderType.PREORDER, OrderType.TERMINAL].includes(form.type) ? 'required' : ''),
      },
      {
        name: 'revelType',
        type: this.revelTypesSelectItems?.length > 0 ? InputType.Select : InputType.Text,
        default: 0,
        label: 'venue.form.checkoutIntegrationProps.revelType',
        items: this.revelTypesSelectItems,
        rules: this.revelTypesSelectItems?.length > 0 ? 'required' : 'required|integer|greater_than:0',
      },
    ];
  }

  get ncrItemsProps() {
    return [
      {
        name: 'nepOrganization',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.nepOrganization',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'nepEnterpriseUnit',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.nepEnterpriseUnit',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'secretKey',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.secretKey',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'sharedKey',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.sharedKey',
        rules: 'required',
        autocomplete: 'off',
      },
    ];
  }

  get ncrPaymentMethodMappingItemProps() {
    return [
      {
        name: 'method',
        type: InputType.Combobox,
        default: PaymentMethod.CASH,
        label: 'venue.form.checkoutIntegrationProps.paymentMethod',
        rules: 'required',
        items: this.paymentMethods,
        clearable: false,
      },
      {
        name: 'ncrType',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.ncrType',
        rules: 'required',
      },
    ];
  }

  get ncrOrderTypeMappingItemProps() {
    return [
      {
        name: 'type',
        type: InputType.Select,
        default: OrderType.PREORDER,
        label: 'venue.form.orderType',
        items: this.orderTypes,
        rules: 'required',
      },
      {
        name: 'subType',
        type: InputType.Select,
        default: SubOrderType.INSIDE,
        label: 'venue.form.subOrderType',
        items: this.subOrderTypes,
        clearable: true,
        rules: (form: any) => ([OrderType.PREORDER, OrderType.TERMINAL].includes(form.type) ? 'required' : ''),
      },
      {
        name: 'ncrType',
        type: InputType.Text,
        default: '',
        label: 'venue.form.checkoutIntegrationProps.ncrType',
        rules: 'required',
      },
    ];
  }

  get arcavisItemsProps() {
    return [
      {
        name: 'integrationKey',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.integrationKey',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'username',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.username',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'password',
        type: InputType.Password,
        label: 'venue.form.checkoutIntegrationProps.password',
        rules: 'required',
        autocomplete: 'new-password',
      },
      {
        name: 'license',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.license',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'tipPaymentMethod',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.tipPaymentMethod',
        rules: 'required',
        autocomplete: 'off',
      },
    ];
  }

  get arcavisPaymentMethodMappingItemProps() {
    return [
      {
        name: 'method',
        type: InputType.Combobox,
        default: PaymentMethod.CASH,
        label: 'venue.form.checkoutIntegrationProps.paymentMethod',
        rules: 'required',
        items: this.paymentMethods,
        clearable: false,
      },
      {
        name: 'arcavisId',
        type: InputType.Text,
        label: 'venue.form.checkoutIntegrationProps.arcavisId',
        rules: 'required|integer|greater_than:0',
        default: 0,
        autocomplete: 'off',
      },
    ];
  }

  public ciSettingsDisabledCallback(form: { checkoutIntegration: string }) {
    return form.checkoutIntegration === 'none';
  }

  public printerSettingsDisabledCallback(form: { hasPrinter: boolean }) {
    return !form.hasPrinter;
  }

  get checkoutIntegrationTypes() {
    return [
      { value: 'none', text: this.$t('common.none') },
      { value: 'antara', text: 'Antara' },
      { value: 'hypersoft', text: 'Hypersoft' },
      { value: 'matrix', text: 'Matrix' },
      { value: 'food_genius', text: 'Food Genius' },
      { value: 'omnivore', text: 'Omnivore' },
      { value: 'hellotess', text: 'helloTESS!' },
      { value: 'deliverect', text: 'Deliverect' },
      { value: 'gastrofix', text: 'Gastrofix' },
      { value: 'simply_delivery', text: 'Simply Delivery' },
      { value: 'polynorm', text: 'Polynorm' },
      { value: 'simphony', text: 'Simphony' },
      { value: 'lightspeed_k_series', text: 'Lightspeed K Series' },
      { value: 'vectron', text: 'Vectron' },
      { value: 'lina_local', text: 'Lina local' },
      { value: 'lina_web', text: 'Lina web' },
      { value: 'kost', text: 'KOST' },
      { value: 'revel', text: 'Revel' },
      { value: 'ncr', text: 'NCR' },
      { value: 'arcavis', text: 'Arcavis' },
    ];
  }

  get orderStatusTypes() {
    return [
      { value: 'none', text: this.$t('orderStatus.none') },
      { value: 'created', text: this.$t('orderStatus.created') },
      { value: 'in_preparation', text: this.$t('orderStatus.in_preparation') },
      { value: 'ready', text: this.$t('orderStatus.ready') },
      { value: 'done', text: this.$t('orderStatus.done') },
      { value: 'in_payment', text: this.$t('orderStatus.in_payment') },
      { value: 'awaiting_confirmation', text: this.$t('orderStatus.awaiting_confirmation') },
    ];
  }

  get paymentMethods() {
    return [
      { value: PaymentMethod.CREDIT_CARD, text: 'Credit card' },
      { value: PaymentMethod.BALANCE, text: 'Balance' },
      { value: PaymentMethod.CASH, text: 'Cash' },
      { value: PaymentMethod.POS, text: 'Pos' },
      { value: PaymentMethod.SEPA, text: 'Sepa' },
      { value: PaymentMethod.APPLE_PAY, text: 'Apple pay' },
      { value: PaymentMethod.GOOGLE_PAY, text: 'Google pay' },
      { value: PaymentMethod.PAYPAL, text: 'Paypal' },
      { value: PaymentMethod.SOFORTBANKING, text: 'Sofortbanking' },
      { value: PaymentMethod.WALLEE, text: 'Walle' },
      { value: PaymentMethod.POSTFINANCE, text: 'Postfinance' },
      { value: PaymentMethod.POSTFINANCE_CARD, text: 'Postfinance Card' },
      { value: PaymentMethod.REKA, text: 'Reka' },
      { value: PaymentMethod.TWINT, text: 'Twint' },
      { value: PaymentMethod.LUNCHECK, text: 'Luncheck' },
      { value: PaymentMethod.BONCARD, text: 'Boncard' },
      { value: PaymentMethod.ALIPAY, text: 'Alipay' },
      { value: PaymentMethod.WECHAT, text: 'Wechat' },
      { value: PaymentMethod.CARD_WORLDLINE, text: 'Worldline' },
      { value: PaymentMethod.TAC, text: 'Tac' },
      { value: PaymentMethod.CCV, text: 'Ccv' },
      { value: PaymentMethod.ZERO_PAYMENT, text: 'Zero Payment' },
      { value: PaymentMethod.EC, text: 'Ec' },
      { value: PaymentMethod.GIROCARD, text: 'Girocard' },
      { value: PaymentMethod.MASTERCARD, text: 'Mastercard' },
      { value: PaymentMethod.AMEX, text: 'Amex' },
      { value: PaymentMethod.VISA, text: 'Visa' },
      { value: PaymentMethod.VISA_E, text: 'Visa e' },
      { value: PaymentMethod.VPAY, text: 'Vpay' },
      { value: PaymentMethod.JCB, text: 'Jcb' },
      { value: PaymentMethod.MAESTRO, text: 'Maestro' },
      { value: PaymentMethod.DINERS, text: 'Diners' },
      { value: PaymentMethod.DISCOVER, text: 'Discover' },
      { value: PaymentMethod.SUBSIDY, text: 'Subsidy' },
      { value: PaymentMethod.OTHER, text: 'Other' },
      { value: PaymentMethod.WORLDLINE_RAW, text: 'Wordline Raw' },
      { value: PaymentMethod.DELIVEROO, text: 'Deliveroo' },
      { value: PaymentMethod.SWISH, text: 'Swish' },
      { value: PaymentMethod.VIPPS, text: 'Vipps' },
      { value: PaymentMethod.MOBILE_PAY, text: 'Mobile Pay' },
      { value: PaymentMethod.DANKORT, text: 'Dankort' },
      { value: PaymentMethod.MAXXVEND, text: 'Maxxvend' },
    ];
  }

  get tableItems() {
    return this.tablesItem.map((table: any) => {
      return {
        text: table.number,
        value: table._id,
      };
    });
  }

  get lightSpeed() {
    return this.checkoutIntegration && this.checkoutIntegration.lightspeed
      ? {
          ...this.checkoutIntegration.lightspeed,
          ...this.checkoutIntegration.lightspeed.orderProfiles,
          ...this.checkoutIntegration.lightspeed.paymentMethodMappings,
          preorderInside: this.checkoutIntegration.lightspeed.priceMappings?.preorder?.inside,
          preorderTakeAway: this.checkoutIntegration.lightspeed.priceMappings?.preorder?.takeAway,
          preorderDelivery: this.checkoutIntegration.lightspeed.priceMappings?.preorder?.delivery,
          terminalInside: this.checkoutIntegration.lightspeed.priceMappings?.terminal?.inside,
          terminalTakeAway: this.checkoutIntegration.lightspeed.priceMappings?.terminal?.takeAway,
          terminalInsideProfile: this.checkoutIntegration.lightspeed.orderProfiles?.terminalInside,
          terminalTakeAwayProfile: this.checkoutIntegration.lightspeed.orderProfiles?.terminalTakeAway,
          woltPrice: this.checkoutIntegration.lightspeed.priceMappings?.wolt,
          uberEatsPrice: this.checkoutIntegration.lightspeed.priceMappings?.uberEats,
          jetPrice: this.checkoutIntegration.lightspeed.priceMappings?.jet,
        }
      : {};
  }

  public async onConfChange(type: string) {
    this.typeConfiguration = type;

    if (this.typeConfiguration === REVEL) {
      await this.getRevelTypes();
    }
  }

  public getData() {
    return { ...this.$refs.form.form };
  }

  public addTender(table: Table, indexTable: number, indexTender: number) {
    if (this.$refs.tenderProps && this.$refs.tenderProps.length) {
      const handledTable = this.$refs.tableProps.find((vueComponent: any) => vueComponent.form.uuid === table.uuid);

      this.tables[indexTable] = {
        ...handledTable.form,
        tenders: [...this.tables[indexTable].tenders],
      };

      this.tables[indexTable].tenders.push({
        paymentMethod: '',
        channelDelivery: '',
        channelInside: '',
        channelTakeaway: '',
        uuid: uuid(),
      });
      this.$forceUpdate();
    }
  }

  public initTable() {
    this.tables.push({
      name: '',
      table: '',
      channelDelivery: '',
      channelInside: '',
      channelTakeaway: '',
      uuid: uuid(),
      tenders: [],
    });
  }

  public initTender(table: Table, indexTable: number) {
    if (this.$refs.tableProps && this.$refs.tableProps.length) {
      const handledTable = this.$refs.tableProps.find((vueComponent: any) => vueComponent.form.uuid === table.uuid);

      this.tables[indexTable] = {
        ...handledTable.form,
        tenders: [
          {
            paymentMethod: '',
            channelDelivery: '',
            channelInside: '',
            channelTakeaway: '',
            uuid: uuid(),
          },
        ],
      };
    }
    this.$forceUpdate();
  }

  public addTable(indexTable: number) {
    if (this.$refs.tableProps && this.$refs.tableProps.length) {
      this.tables[indexTable] = {
        ...this.$refs.tableProps[this.$refs.tableProps.length - 1]?.form,
        tenders: [...this.tables[indexTable].tenders],
      };
      this.tables.push({
        name: '',
        table: '',
        channelDelivery: '',
        channelInside: '',
        channelTakeaway: '',
        uuid: uuid(),
        tenders: [],
      });
    }
  }

  public removeTable(index: number) {
    this.tables[this.tables.length - 1] = {
      ...this.$refs.tableProps[this.$refs.tableProps.length - 1]?.form,
      tenders: [...this.tables[this.tables.length - 1].tenders],
    };
    this.tables.splice(index, 1);
  }

  public removeTender(indexTable: number, indexTender: number) {
    this.tables[indexTable].tenders[this.tables[indexTable].tenders.length - 1] = {
      ...this.$refs.tenderProps[this.$refs.tenderProps.length - 1]?.form,
    };
    this.tables[indexTable].tenders.splice(indexTender, 1);
    this.$forceUpdate();
  }

  public initSimphonyTender() {
    this.simphonyTenders.push({
      name: '',
      paymentMethod: '',
      tenderId: 0,
      uuid: uuid(),
    });
  }

  public removeSimphonyTender(index: number) {
    this.simphonyTenders.splice(index, 1);
  }

  public initSimphonyTerminalRevenueCenter() {
    this.simphonyTerminalRevenueCenters.push({
      revenueCenter: '',
      subOrderType: SubOrderType.INSIDE,
    });
  }

  public removeSimphonyTerminalRevenueCenter(index: number) {
    this.simphonyTerminalRevenueCenters.splice(index, 1);
  }

  public initSimphonyPreOrderRevenueCenter() {
    this.simphonyPreOrderRevenueCenters.push({
      revenueCenter: '',
      subOrderType: SubOrderType.INSIDE,
    });
  }

  public removeSimphonyPreOrderRevenueCenter(index: number) {
    this.simphonyPreOrderRevenueCenters.splice(index, 1);
  }

  public initSimphonyExternalOrderProviderRevenueCenter() {
    this.simphonyExternalOrderProviderRevenueCenters.push({
      revenueCenter: '',
      type: ExternalOrderProvider.WOLT,
      subOrderType: SubOrderType.INSIDE,
    });
  }

  public removeSimphonyExternalOrderProviderRevenueCenter(index: number) {
    this.simphonyExternalOrderProviderRevenueCenters.splice(index, 1);
  }

  public initHellotessTender() {
    this.hellotessTenders.push({
      name: '',
      paymentMethod: '',
      tenderId: '',
      uuid: uuid(),
    });
  }

  public removeHellotessTender(index: number) {
    this.hellotessTenders.splice(index, 1);
  }

  public toggleRevelPaymentMethodMapping(index?: number) {
    if (index === undefined) {
      this.revelPaymentMethodMappings.push({
        method: undefined,
        revelType: 0,
        isDefault: false,
      });

      return;
    }

    this.revelPaymentMethodMappings.splice(index, 1);
  }

  public toggleRevelOrderTypeMapping(index?: number) {
    if (index === undefined) {
      this.revelOrderTypeMappings.push({
        type: OrderType.PREORDER,
        subType: SubOrderType.INSIDE,
        revelType: 0,
      });

      return;
    }

    this.revelOrderTypeMappings.splice(index, 1);
  }

  public toggleNcrPaymentMethodMapping(index?: number) {
    if (index === undefined) {
      this.ncrPaymentMethodMappings.push({
        method: PaymentMethod.CASH,
        ncrType: '',
      });

      return;
    }

    this.ncrPaymentMethodMappings.splice(index, 1);
  }

  public toggleNcrOrderTypeMapping(index?: number) {
    if (index === undefined) {
      this.ncrOrderTypeMappings.push({
        type: OrderType.PREORDER,
        subType: SubOrderType.INSIDE,
        ncrType: '',
      });

      return;
    }

    this.ncrOrderTypeMappings.splice(index, 1);
  }

  public toggleArcavisPaymentMethodMapping(index?: number) {
    if (index === undefined) {
      this.arcavisPaymentMethodMappings.push({
        method: PaymentMethod.CASH,
        arcavisId: 0,
      });

      return;
    }

    this.arcavisPaymentMethodMappings.splice(index, 1);
  }

  public syncLightspeed() {
    if (!this.selectedLightspeedSyncMode) {
      return;
    }
    if (this.selectedLightspeedSyncMode === LightspeedSyncMode.TABLES) {
      return this.syncLightspeedTables();
    }
    return this.syncLightspeedFoodcard();
  }

  public async syncLightspeedTables() {
    this.$startLoading('lightspeed.tables');
    const api: LightspeedApiService = new LightspeedApiService();
    api
      .syncTables({ venue: this.$route.params.id })
      .then(() => {
        this.notifySuccess('lightspeed.notification.tablesSyncSuccess');
        this.$stopLoading('lightspeed.tables');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError('lightspeed.notification.tablesSyncError');
        this.$stopLoading('lightspeed.tables');
      });
  }

  public syncLightspeedFoodcard() {
    this.$startLoading('lightspeed.foodcard');
    const api: LightspeedApiService = new LightspeedApiService();
    api
      .syncFoodcard({ venue: this.$route.params.id || '', mode: this.selectedLightspeedSyncMode as LightspeedSyncMode })
      .then(() => {
        this.notifySuccess('lightspeed.notification.foodcardSyncSuccess');
        this.$stopLoading('lightspeed.foodcard');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError('lightspeed.notification.foodcardSyncError');
        this.$stopLoading('lightspeed.foodcard');
      });
  }

  public getLightspeedMenus() {
    this.$startLoading('lightspeed.menus');
    const api: LightspeedApiService = new LightspeedApiService();
    api
      .getMenus(this.$route.params.id || '')
      .then((res: AxiosResponse<LightspeedMenu[]>) => {
        this.lightspeedMenus = res.data || [];
      })
      .catch((err: Error) => {
        console.error(err);
      })
      .finally(() => {
        this.$stopLoading('lightspeed.menus');
      });
  }

  public getRevelTypes() {
    if (!this.checkoutIntegration?.revel?.enabled) {
      return;
    }

    this.$startLoading('revel.types');
    const api: RevelApiService = new RevelApiService();
    api
      .getTypes(this.$route.params.id || '')
      .then((res: AxiosResponse<RevelType[]>) => {
        this.revelTypes = res.data || [];
      })
      .catch((err: Error) => {
        console.error(err);
      })
      .finally(() => {
        this.$stopLoading('revel.types');
      });
  }

  public addPrice() {
    this.prices.push({
      orderProfile: '',
      value: '',
    });
  }

  public removePrice(item: PriceType) {
    this.prices.splice(this.prices.indexOf(item), 1);
  }

  public addDiscountArticle() {
    this.discountArticles.push({
      taxRate: '',
      sku: '',
    });
  }

  public removeDiscountArticle(item: DiscountArticle) {
    this.discountArticles.splice(this.discountArticles.indexOf(item), 1);
  }

  public refreshCnc() {
    if (!this.isCncEnabled) {
      return;
    }

    this.$startLoading('simphony.cnc');

    const api: SimphonyApiService = new SimphonyApiService();
    api
      .refreshCnc({ venue: this.$route.params.id || '' })
      .then(() => {
        this.notifySuccess('simphony.notification.refreshCncSuccess');
        this.$stopLoading('simphony.cnc');
      })
      .catch((err: Error) => {
        this.notifyError('simphony.notification.refreshCncError');
        this.$stopLoading('simphony.cnc');
      });
  }

  public syncSimphonyFoodcard(mode: SimphonySyncMode, success: string, error: string, v2?: boolean) {
    this.$startLoading('simphony.foodcard');
    const api: SimphonyApiService = new SimphonyApiService();
    api
      .syncFoodcard({ venue: this.$route.params.id || '', mode, v2 })
      .then(() => {
        this.notifySuccess(success);
        this.$stopLoading('simphony.foodcard');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError(error);
        this.$stopLoading('simphony.foodcard');
      });
  }

  public syncKostFoodcard() {
    this.$startLoading('kost.foodcard');
    const api: KostApiService = new KostApiService();
    api
      .syncFoodcard({ venue: this.$route.params.id || '' })
      .then(() => {
        this.notifySuccess('kost.notification.foodcardSyncSuccess');
        this.$stopLoading('kost.foodcard');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError('kost.notification.foodcardSyncError');
        this.$stopLoading('kost.foodcard');
      });
  }

  public syncNcrFoodcard() {
    this.$startLoading('ncr.foodcard');
    const api: NcrApiService = new NcrApiService();
    api
      .syncFoodcard({ venue: this.$route.params.id || '' })
      .then(() => {
        this.notifySuccess('ncr.notification.foodcardSyncSuccess');
        this.$stopLoading('ncr.foodcard');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError('ncr.notification.foodcardSyncError');
        this.$stopLoading('ncr.foodcard');
      });
  }

  public syncRevelMenu() {
    if (!this.$can(Permission.ADMIN) || !this.checkoutIntegration?.revel?.enabled) {
      return;
    }
    this.$startLoading('revel.menu');
    const api: RevelApiService = new RevelApiService();
    api
      .syncMenu({ venue: this.$route.params.id || '', mode: this.selectedRevelSyncMode as RevelSyncMode })
      .then(() => {
        this.notifySuccess('revel.notification.menuSyncSuccess');
        this.$stopLoading('revel.menu');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError('revel.notification.menuSyncError');
        this.$stopLoading('revel.menu');
      });
  }

  public syncLinaPrices() {
    this.$startLoading('lina.prices');
    const api: SyncPricesApiService = new SyncPricesApiService();
    api
      .syncPrices({
        venue: this.$route.params.id || '',
        checkoutIntegration: this.typeConfiguration,
        mode: 'default',
      })
      .then(() => {
        this.notifySuccess('lina.notification.pricesSyncSuccess');
        this.$stopLoading('lina.prices');
      })
      .catch((err: Error) => {
        console.error(err);
        this.notifyError('lina.notification.pricesSyncError');
        this.$stopLoading('lina.prices');
      });
  }

  public prepareSimphonyProps() {
    if (this.$refs.simphonyProps && this.$refs.simphonyProps.form) {
      const simphonyProps = { ...this.$refs.simphonyProps.form };

      Object.keys(simphonyProps).map((key: string) => {
        if (simphonyProps[key as keyof SimphonyIntegration] === '') {
          simphonyProps[key] = null;
        }
      });

      if (simphonyProps.excludedTenders && simphonyProps.excludedTenders !== '') {
        simphonyProps.excludedTenders = simphonyProps.excludedTenders.split(',');
      }

      if (simphonyProps.multiConventionalRevenueCenters && simphonyProps.multiConventionalRevenueCenters !== '') {
        simphonyProps.multiConventionalRevenueCenters = simphonyProps.multiConventionalRevenueCenters.split(',');
      }

      if (simphonyProps?.useNotesAsOrderCodeEnabled) {
        simphonyProps.useNotesAsOrderCode = {
          enabled: simphonyProps.useNotesAsOrderCodeEnabled,
          orderTypes: simphonyProps.simphonyOrderTypes || [],
        };

        delete simphonyProps.useNotesAsOrderCodeEnabled;
        delete simphonyProps.simphonyOrderTypes;
      }

      return simphonyProps;
    } else {
      return {};
    }
  }

  public getIntegrationByType() {
    const venue: Venue = this.initialValues as Venue;

    if (venue?.checkoutIntegration === ANTARA) {
      return this.checkoutIntegration?.antara;
    } else if (venue?.checkoutIntegration === HELLOTESS) {
      return this.checkoutIntegration?.hellotess;
    } else if (venue?.checkoutIntegration === GASTROFIX) {
      return this.checkoutIntegration?.gastrofix;
    } else if (venue?.checkoutIntegration === LINA_LOCAL) {
      return this.checkoutIntegration?.linaLocal;
    } else if (venue?.checkoutIntegration === LINA_WEB) {
      return this.checkoutIntegration?.linaWeb;
    } else if (venue?.checkoutIntegration === KOST) {
      return this.checkoutIntegration?.kost;
    } else if (venue?.checkoutIntegration === REVEL) {
      return this.checkoutIntegration?.revel;
    } else if (venue?.checkoutIntegration === NCR) {
      return this.checkoutIntegration?.ncr;
    } else if (venue?.checkoutIntegration === ARCAVIS) {
      return this.checkoutIntegration?.arcavis;
    }

    return {};
  }

  public async isValidIntegrationProps(): Promise<{ refKey: any; result: boolean }> {
    if (this.typeConfiguration !== this.deliverect) return { refKey: null, result: true };
    return this.isValidWithKey(await this.validateRefs(this.$refs.tableProps));
  }

  public getIntegrationProperties() {
    const integrationProps = {
      ...(this.$refs.integrationProps && this.$refs.integrationProps.form ? this.$refs.integrationProps.form : null),
    };

    if (!integrationProps) return {};

    if (this.typeConfiguration === this.antara) {
      let generalProps: any = {};
      generalProps.ip = integrationProps?.ip;
      generalProps.port = integrationProps?.port;
      generalProps.storeId = integrationProps?.storeId;
      generalProps.scheduleSync = integrationProps?.scheduleSync;
      generalProps.lastResult = integrationProps?.lastResult;
      return {
        antara: { ...generalProps },
      };
    } else if (this.typeConfiguration === this.deliverect) {
      const tables = this.tables.map((table: Table) => {
        return {
          ...this.$refs.tableProps.find((item: any) => item.form.uuid === table.uuid).form,
          tenders: table.tenders.map(
            (tender: Tender) => this.$refs.tenderProps.find((item: any) => item.form.uuid === tender.uuid).form,
          ),
        };
      });

      const deliverectProps = {
        ...(this.$refs.deliverectProps && this.$refs.deliverectProps.form ? this.$refs.deliverectProps.form : null),
      };

      return {
        deliverect: {
          tables,
          ...deliverectProps,
        },
      };
    } else if (this.typeConfiguration === this.gastrofix) {
      return {
        gastrofix: {
          gastrofixApiKey: integrationProps.gastrofixApiKey,
          gastrofixBusinessUnit: integrationProps.gastrofixBusinessUnit,
        },
      };
    } else if (this.typeConfiguration === this.hellotess) {
      return {
        hellotess: {
          useV2: integrationProps.useV2,
          storeId: integrationProps.storeId,
          paymentMethod: integrationProps.paymentMethod,
          hellotessApiBaseUrl: integrationProps.hellotessApiBaseUrl,
          hellotessApiKey: integrationProps.hellotessApiKey,
          tenders: this.$refs.hellotessTenderProps?.map(
            (tenderRef: {
              form: {
                name: string;
                tenderId: string;
                paymentMethod: string | { name: string; value: string };
                uuid?: string;
              };
            }) => {
              if (tenderRef && tenderRef.form && typeof tenderRef.form.paymentMethod === 'object') {
                tenderRef.form.paymentMethod = tenderRef.form.paymentMethod?.value;
              }
              delete tenderRef?.form?.uuid;
              return tenderRef?.form;
            },
          ),
        },
      };
    } else if (this.typeConfiguration === this.simphony) {
      return {
        simphony: {
          ...this.prepareSimphonyProps(),
          tenders: this.$refs.simphonyTenderProps?.map(
            (tenderRef: {
              form: {
                name: string;
                tenderId: number;
                paymentMethod: string | { name: string; value: string };
                uuid?: string;
              };
            }) => {
              if (tenderRef && tenderRef.form && typeof tenderRef.form.paymentMethod === 'object') {
                tenderRef.form.paymentMethod = tenderRef.form.paymentMethod?.value;
              }
              delete tenderRef?.form?.uuid;
              return tenderRef?.form;
            },
          ),
          terminalRevenueCenterMapping: this.$refs.simphonyTerminalRevenueCenterProps?.map(
            (revenueCenterRef: {
              form: {
                revenueCenter: string;
                subOrderType: string;
              };
            }) => {
              return revenueCenterRef.form;
            },
          ),
          preOrderRevenueCenterMapping: this.$refs.simphonyPreOrderRevenueCenterProps?.map(
            (revenueCenterRef: {
              form: {
                revenueCenter: string;
                subOrderType: string;
              };
            }) => {
              return revenueCenterRef.form;
            },
          ),
          externalOrderProviderRevenueCenterMapping: this.$refs.simphonyExternalOrderProviderRevenueCenterProps?.map(
            (revenueCenterRef: {
              form: {
                revenueCenter: string;
                type: string;
                subOrderType: string;
              };
            }) => {
              return revenueCenterRef.form;
            },
          ),
        },
      };
    } else if (this.typeConfiguration === this.lightspeedKSeries) {
      return {
        lightspeed: {
          ...(this.$refs.lightspeedProps && this.$refs.lightspeedProps.form ? this.$refs.lightspeedProps.form : {}),
          orderProfiles: {
            inside: this.$refs.lightspeedProps?.form?.inside,
            takeAway: this.$refs.lightspeedProps?.form?.takeAway,
            delivery: this.$refs.lightspeedProps?.form?.delivery,
            woltTakeAway: this.$refs.lightspeedProps?.form?.woltTakeAway,
            woltDelivery: this.$refs.lightspeedProps?.form?.woltDelivery,
            uberEatsTakeAway: this.$refs.lightspeedProps?.form?.uberEatsTakeAway,
            uberEatsDelivery: this.$refs.lightspeedProps?.form?.uberEatsDelivery,
            jetTakeAway: this.$refs.lightspeedProps?.form?.jetTakeAway,
            jetDelivery: this.$refs.lightspeedProps?.form?.jetDelivery,
            deliverooTakeAway: this.$refs.lightspeedProps?.form?.deliverooTakeAway,
            deliverooDelivery: this.$refs.lightspeedProps?.form?.deliverooDelivery,
            terminalInside: this.$refs.lightspeedProps?.form?.terminalInsideProfile,
            terminalTakeAway: this.$refs.lightspeedProps?.form?.terminalTakeAwayProfile,
            webInside: this.$refs.lightspeedProps?.form?.webInside,
            webTakeAway: this.$refs.lightspeedProps?.form?.webTakeAway,
            webDelivery: this.$refs.lightspeedProps?.form?.webDelivery,
            appInside: this.$refs.lightspeedProps?.form?.appInside,
            appTakeAway: this.$refs.lightspeedProps?.form?.appTakeAway,
            appDelivery: this.$refs.lightspeedProps?.form?.appDelivery,
          },
          paymentMethodMappings: {
            creditCard: this.$refs.lightspeedProps?.form?.creditCard,
            pos: this.$refs.lightspeedProps?.form?.pos,
            cash: this.$refs.lightspeedProps?.form?.cash,
            applePay: this.$refs.lightspeedProps?.form?.applePay,
            googlePay: this.$refs.lightspeedProps?.form?.googlePay,
            paypal: this.$refs.lightspeedProps?.form?.paypal,
            boncard: this.$refs.lightspeedProps?.form?.boncard,
            wolt: this.$refs.lightspeedProps?.form?.wolt,
            jet: this.$refs.lightspeedProps?.form?.jet,
            uberEats: this.$refs.lightspeedProps?.form?.uberEats,
            sepa: this.$refs.lightspeedProps?.form?.sepa,
            ec: this.$refs.lightspeedProps?.form?.ec,
            girocard: this.$refs.lightspeedProps?.form?.girocard,
            mastercard: this.$refs.lightspeedProps?.form?.mastercard,
            amex: this.$refs.lightspeedProps?.form?.amex,
            visa: this.$refs.lightspeedProps?.form?.visa,
            visaE: this.$refs.lightspeedProps?.form?.visaE,
            vPay: this.$refs.lightspeedProps?.form?.vPay,
            maestro: this.$refs.lightspeedProps?.form?.maestro,
            postcard: this.$refs.lightspeedProps?.form?.postcard,
            alipay: this.$refs.lightspeedProps?.form?.alipay,
            diners: this.$refs.lightspeedProps?.form?.diners,
            lunchcheck: this.$refs.lightspeedProps?.form?.lunchcheck,
            reka: this.$refs.lightspeedProps?.form?.reka,
            twint: this.$refs.lightspeedProps?.form?.twint,
            chinaUnionPay: this.$refs.lightspeedProps?.form?.chinaUnionPay,
            piggyPrepaidBalance: this.$refs.lightspeedProps?.form?.piggyPrepaidBalance,
            piggyGiftCard: this.$refs.lightspeedProps?.form?.piggyGiftCard,
            zeroPayment: this.$refs.lightspeedProps?.form?.zeroPayment,
            deliveroo: this.$refs.lightspeedProps?.form?.deliveroo,
            postfinance: this.$refs.lightspeedProps?.form?.postfinance,
          },
          priceMappings: {
            preorder: {
              inside: this.$refs.lightspeedProps?.form?.preorderInside,
              takeAway: this.$refs.lightspeedProps?.form?.preorderTakeAway,
              delivery: this.$refs.lightspeedProps?.form?.preorderDelivery,
            },
            terminal: {
              inside: this.$refs.lightspeedProps?.form?.terminalInside,
              takeAway: this.$refs.lightspeedProps?.form?.terminalTakeAway,
            },
            wolt: this.$refs.lightspeedProps?.form?.woltPrice,
            uberEats: this.$refs.lightspeedProps?.form?.uberEatsPrice,
            jet: this.$refs.lightspeedProps?.form?.jetPrice,
            deliveroo: this.$refs.lightspeedProps?.form?.deliverooPrice,
            prices: this.prices,
          },
          ...(this.discountArticles.length && {
            discountArticles: this.discountArticles,
          }),
        },
      };
    } else if (this.typeConfiguration === this.vectron) {
      return {
        vectron: {
          ...this.$refs.vectronProps.form,
        },
      };
    } else if (this.typeConfiguration === this.kost) {
      return {
        kost: {
          ...this.$refs.kostProps.form,
        },
      };
    } else if (this.typeConfiguration === this.revel) {
      const mainFormValues = this.$refs.revelProps?.form || {};
      const paymentMappingRefs = this.$refs.revelPaymentMethodMappingProps || [];
      const orderTypeMappingRefs = this.$refs.revelOrderTypeMappingProps || [];

      const paymentMethodMappings = (Array.isArray(paymentMappingRefs) ? paymentMappingRefs : [paymentMappingRefs]).map(
        (ref: any) => {
          const formData = ref.form || {};
          let method = formData.method;

          if (method && typeof method === 'object' && method.value !== undefined) {
            method = method.value;
          }

          return {
            isDefault: formData.isDefault,
            method,
            revelType: formData.revelType,
          };
        },
      );

      const orderTypeMappings = (
        Array.isArray(orderTypeMappingRefs) ? orderTypeMappingRefs : [orderTypeMappingRefs]
      ).map((ref: any) => {
        const formData = ref.form || {};
        let type = formData.type;
        let subType = formData.subType;

        if (type && typeof type === 'object' && type.value !== undefined) {
          type = type.value;
        }

        if (subType && typeof subType === 'object' && subType.value !== undefined) {
          subType = subType.value;
        }

        return {
          type,
          subType,
          revelType: formData.revelType,
        };
      });

      return {
        revel: {
          ...mainFormValues,
          paymentMethodMappings,
          orderTypeMappings,
        },
      };
    } else if (this.typeConfiguration === this.ncr) {
      const mainFormValues = this.$refs.ncrProps?.form || {};
      const paymentMappingRefs = this.$refs.ncrPaymentMethodMappingProps || [];
      const orderTypeMappingRefs = this.$refs.ncrOrderTypeMappingProps || [];

      const paymentMethodMappings = (Array.isArray(paymentMappingRefs) ? paymentMappingRefs : [paymentMappingRefs]).map(
        (ref: any) => {
          const formData = ref.form || {};
          let method = formData.method;

          if (method && typeof method === 'object' && method.value !== undefined) {
            method = method.value;
          }

          return {
            method,
            ncrType: formData.ncrType,
          };
        },
      );

      const orderTypeMappings = (
        Array.isArray(orderTypeMappingRefs) ? orderTypeMappingRefs : [orderTypeMappingRefs]
      ).map((ref: any) => {
        const formData = ref.form || {};
        let type = formData.type;
        let subType = formData.subType;

        if (type && typeof type === 'object' && type.value !== undefined) {
          type = type.value;
        }

        if (subType && typeof subType === 'object' && subType.value !== undefined) {
          subType = subType.value;
        }

        return {
          type,
          subType,
          ncrType: formData.ncrType,
        };
      });

      return {
        ncr: {
          ...mainFormValues,
          paymentMethodMappings,
          orderTypeMappings,
        },
      };
    } else if (this.typeConfiguration === this.arcavis) {
      console.log(this.typeConfiguration);
      const mainFormValues = this.$refs.arcavisProps?.form || {};
      const paymentMappingRefs = this.$refs.arcavisPaymentMethodMappingProps || [];

      const paymentMethodMappings = (Array.isArray(paymentMappingRefs) ? paymentMappingRefs : [paymentMappingRefs]).map(
        (ref: any) => {
          const formData = ref.form || {};
          let method = formData.method;

          if (method && typeof method === 'object' && method.value !== undefined) {
            method = method.value;
          }

          return {
            method,
            arcavisId: formData.arcavisId,
          };
        },
      );

      return {
        arcavis: {
          ...mainFormValues,
          paymentMethodMappings,
        },
      };
    }
  }
}
